module.exports = __webpack_public_path__ + "img/full4-min.4a475cab.png";